export const DOUBLETICK_ENTERPRISE_PLANS = [
  {
    name: 'Standard',
    value: 'STANDARD'
  },
  {
    name: 'Pro',
    value: 'PRO'
  },
  {
    name: 'Enterprise',
    value: 'ENTERPRISE'
  }
];



// WEBPACK FOOTER //
// ./src/utils/constans.js